export default "__VITE_ASSET__hryzUidu__"